import React, { useState, useEffect } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react';

function Faq() {

 const questions = [
  {
   "question": "What factors should I consider before getting a tattoo?",
   "answer": "Before getting a tattoo, consider factors such as the design you want, the placement of the tattoo, the reputation of the tattoo artist, the cleanliness of the tattoo studio, your pain tolerance, and any potential health risks."
  },
  {
   "question": "Does getting a tattoo hurt?",
   "answer": "Pain levels can vary depending on factors such as the placement of the tattoo, your pain tolerance, and the size and style of the tattoo. Some areas of the body are more sensitive than others, but many people describe the sensation as similar to a hot scratching feeling."
  },
  {
   "question": "How should I prepare for getting a tattoo?",
   "answer": "To prepare for getting a tattoo, make sure you eat a good meal beforehand, stay hydrated, get plenty of rest, avoid alcohol and blood-thinning medications, and wear comfortable clothing that allows easy access to the area being tattooed."
  },
  {
   "question": "What should I do immediately after getting a tattoo?",
   "answer": "After getting a tattoo, your artist will likely apply a protective covering and provide you with aftercare instructions. Follow these instructions carefully, which typically involve keeping the tattoo clean and moisturized, avoiding direct sunlight and swimming, and refraining from picking at any scabs that may form."
  },
  {
   "question": "How long does it take for a tattoo to heal?",
   "answer": "The healing process for a tattoo usually takes about 2-3 weeks, but it can vary depending on factors such as the size and complexity of the tattoo, your skin type, and how well you follow aftercare instructions."
  },
  {
   "question": "Can I go swimming after getting a tattoo?",
   "answer": "It's generally recommended to avoid swimming, especially in pools, hot tubs, and natural bodies of water, until your tattoo is fully healed. Water can introduce bacteria and other contaminants to the tattoo, increasing the risk of infection."
  },
  {
   "question": "Is it normal for my tattoo to scab?",
   "answer": "Yes, it's normal for a tattoo to scab during the healing process. Scabbing is a natural part of the skin's healing response to trauma. It's important not to pick at the scabs, as this can damage the tattoo and increase the risk of infection."
  },
  {
   "question": "How often should I moisturize my tattoo?",
   "answer": "You should moisturize your tattoo several times a day, especially during the first few weeks of healing. Use a gentle, fragrance-free moisturizer to keep the tattooed area hydrated and promote proper healing."
  },
  {
   "question": "Can I exercise after getting a tattoo?",
   "answer": "It's generally okay to engage in light exercise after getting a tattoo, but avoid activities that cause excessive sweating or friction on the tattooed area. It's important to listen to your body and avoid anything that causes discomfort or irritation to the tattoo."
  },
  {
   "question": "When can I expose my tattoo to sunlight?",
   "answer": "It's best to keep your tattoo out of direct sunlight during the healing process, as sun exposure can cause fading and other damage to the tattoo. Once your tattoo is fully healed, be sure to apply sunscreen with a high SPF to protect it from UV rays whenever it will be exposed to sunlight."
  },
  {
   "question": "What should I do if my tattoo becomes infected?",
   "answer": "If you suspect that your tattoo is infected (signs may include increased pain, redness, swelling, or discharge), it's important to seek medical attention promptly. Your doctor may prescribe antibiotics to treat the infection and provide guidance on caring for the affected area."
  },
  {
   "question": "How can I prevent my tattoo from fading?",
   "answer": "To prevent your tattoo from fading, avoid prolonged exposure to sunlight, especially during the first few months after getting the tattoo. Additionally, use a high SPF sunscreen to protect the tattoo whenever it will be exposed to sunlight, and moisturize the tattoo regularly to keep the skin healthy and hydrated."
  }
 ]


 const [expandedIndex, setExpandedIndex] = useState(null);


 const toggleQuestion = (index) => {
  if (expandedIndex === index) {
   setExpandedIndex(null);
  } else {
   setExpandedIndex(index);
  }
 };

 //scroll to Top on mount
 useEffect(() => {
  window.scrollTo(0, 0);
 }, []);

 return (
  <div className='mt-[8rem] mx-4 mb-[4rem]'>
   <h1 className="text-[4rem] mt-[6rem] md:text-[10rem] opacity-10 font-bold hidden md:block absolute top-[-2.5rem]">
    questions
   </h1>
   <h2 className="text-[2rem] md:pt-[8rem] md:pl-[20rem] border-b border-white mr-[6rem] pl-6 md:border-none mb-10">
    <span className='hidden lg:inline'>frequently</span> asked questions
   </h2>

   {questions.map((question, index) => (
    <div key={index} className="border border-b border-[#7d7d7d] p-4 rounded-md my-4 lg:mx-16 xl:mx-[6rem] 2xl:mx-[8rem]">
     <button
      className="flex items-center justify-between cursor-pointer gap-1 md:gap-3"
      onClick={() => toggleQuestion(index)}
     >
      {expandedIndex === index ? <ChevronUp /> : <ChevronDown />}
      <span className='text-[#d2a88e] text-[1.1rem]'>{question.question}</span>
     </button>
     {expandedIndex === index && (
      <p className='text-[.9rem] mt-2'>{question.answer}</p>
     )}
    </div>
   ))}
  </div>
 );
}

export default Faq;